import { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Tooltip,
  IconButton,
  TextField,
  Dialog,
  DialogContent,
  Autocomplete,
} from "@mui/material";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { DataGrid, faIR } from "@mui/x-data-grid";
import CustomPagination from "../../components/CustomPagination";
import EditIcon from "@mui/icons-material/Edit";
import "react-lazy-load-image-component/src/effects/blur.css";
import DeleteRow from "../../components/DeleteRow";
import DeleteIcon from "@mui/icons-material/Delete";
import { UseArticles } from "./UseArticles";
import { useSnackbar } from "notistack";
import CheckIcon from "@mui/icons-material/Check";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { UseMagAdvertisment } from "../../Mag-Content/mag-Adv/UseMagAdvertisment";
import CachedIcon from "@mui/icons-material/Cached";
import LinkIcon from "@mui/icons-material/Link";

export default function ArticleAdvsGrid(props) {
  const { enqueueSnackbar } = useSnackbar();
  const {
    GetAllAdvs,
    GetArticleAdvs,
    AddArticleAdv,
    DeleteArticleAdv,
    EditArticleAdv,
  } = UseArticles();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [openDialog, setOpenDialog] = useState(false);
  const [pageState, setPageState] = useState({
    page: 1,
  });
  const [searchSubGroup, setSearchSubGroup] = useState("");
  const [advsRes, setAdvsRes] = useState([]);
  const [allAdvsRes, setAllAdvsRes] = useState([]);
  const [filt, setFilt] = useState([]);
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });
  const { GetMagAdvTypes } = UseMagAdvertisment();
  const [types, setTypes] = useState([]);

  const [state, setState] = useState({
    articleID: 0,
    adsID: "",
  });

  useEffect(() => {
    GetMagAdvTypes((type) => {
      setTypes(type.items);
    });
  }, []);

  useEffect(() => {
    if (props.articleID) {
      setProgress(true);
      GetAllAdvs((callback) => {
        setAllAdvsRes(callback);
      });
      GetArticleAdvs(props.articleID, (callback) => {
        setAdvsRes(callback);
      });
    }
  }, [props.articleID]);

  useEffect(() => {
    setFilt([
      {
        columnField: "resource",
        operatorValue: "contains",
        value: searchSubGroup,
      },
    ]);
  }, [searchSubGroup]);

  const newFunc = () => {
    setOpenDialog(true);
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
    },
    {
      field: "title",
      width: 230,
      align: "center",
      headerName: "عنوان",
      headerAlign: "center",
    },
    {
      field: "type",
      width: 150,
      align: "center",
      headerName: "نوع",
      headerAlign: "center",
    },
    {
      field: "url",
      headerName: "آدرس",
      width: 300,
      align: "right",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              direction: "rtl",
              whiteSpace: "normal",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {cellValues.row.url ? cellValues.row.url : "بدون آدرس"}
          </Typography>
        );
      },
    },

    {
      field: "عملیات",
      sortable: false,
      width: 140,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <>
            <Tooltip title="حذف">
              <IconButton
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.title,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="ویرایش">
              <IconButton
                onClick={() => {
                  setOpenDialog(true);
                  setState(cellValues.row);
                }}
              >
                <EditIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <IconButton
              sx={{ p: 0.5, mr: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  orderRow: cellValues.row.orderRow - 1,
                };
                if (cellValues.row.orderRow - 1 == 0) {
                  return;
                } else {
                  setProgress(true);
                  EditArticleAdv(model, () =>
                    GetArticleAdvs(props.articleID, (callback) => {
                      setAdvsRes(callback);
                    })
                  );
                }
              }}
            >
              <ArrowDropUpIcon fontSize="small" sx={{}} />
            </IconButton>
            <IconButton
              sx={{ p: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  orderRow: cellValues.row.orderRow + 1,
                };
                if (cellValues.row.orderRow + 1 == advsRes.length + 1) {
                  return;
                } else {
                  setProgress(true);
                  EditArticleAdv(model, () =>
                    GetArticleAdvs(props.articleID, (callback) => {
                      setAdvsRes(callback);
                    })
                  );
                }
              }}
            >
              <ArrowDropDownIcon fontSize="small" sx={{}} />
            </IconButton>
          </>
        );
      },
    },
  ];

  return (
    <Box sx={{ height: "30rem" }}>
      <Dialog
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        open={openDialog}
        onClose={() => {
          setState({
            articleID: props.articleID,
            adsID: "",
          });
          setOpenDialog(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            {state.id ? (
              <TextField
                sx={{ width: "70%", mb: 3 }}
                label="تبلیغ"
                value={state.title ? state.title : ""}
                size="small"
                variant="filled"
              />
            ) : (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "70%",
                  mb: 3,
                }}
              >
                <Autocomplete
                  size="small"
                  value={state.adsID ? state.adsID : ""}
                  onChange={(event, newValue) => {
                    setState({ articleID: props.articleID, adsID: newValue });
                  }}
                  isOptionEqualToValue={(option, value) => {
                    return value == "" || option === value;
                  }}
                  getOptionLabel={(option) => {
                    if (option) {
                      return allAdvsRes?.find((m) => m.id == option)?.title;
                    }
                    return "";
                  }}
                  sx={{ width: "100%" }}
                  options={allAdvsRes ? allAdvsRes.map((m) => m.id) : []}
                  renderInput={(params) => (
                    <TextField variant="outlined" {...params} label="تبلیغ" />
                  )}
                />
                <IconButton
                  sx={{ p: 0, m: 1 }}
                  onClick={() => {
                    GetAllAdvs((brands) => {
                      setAllAdvsRes(brands);
                    });
                  }}
                >
                  <CachedIcon fontSize="small" />
                </IconButton>
                <IconButton sx={{ p: 0 }} href="/magadvmanage" target="_blank">
                  <LinkIcon fontSize="small" />
                </IconButton>
              </Box>
            )}
            <Autocomplete
              size="small"
              value={state.typeID ? state.typeID : ""}
              onChange={(event, newValue) => {
                setState({ ...state, typeID: newValue });
              }}
              isOptionEqualToValue={(option, value) => {
                return value == "" || option === value;
              }}
              getOptionLabel={(option) => {
                if (option) {
                  return types?.find((m) => m.id == option)?.title;
                }
                return "";
              }}
              sx={{ width: "70%", mb: 3 }}
              options={types ? types.map((m) => m.id) : []}
              renderInput={(params) => (
                <TextField variant="outlined" {...params} label="نوع" />
              )}
            />

            <Box>
              <Button
                onClick={() => {
                  if (
                    !state.id &&
                    (state.adsID == "" ||
                      state.adsID == undefined ||
                      state.adsID == null ||
                      state.typeID == "" ||
                      state.typeID == undefined ||
                      state.typeID == null)
                  ) {
                    enqueueSnackbar("لطفا تبلیغ و نوع آن را وارد کنید", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });

                    return;
                  } else {
                    if (state.id) {
                      setProgress(true);
                      EditArticleAdv(state, () =>
                        GetArticleAdvs(props.articleID, (callback) => {
                          setState({
                            articleID: props.articleID,
                            adsID: "",
                          });
                          setAdvsRes(callback);
                          setOpenDialog(false);
                        })
                      );
                    } else {
                      setProgress(true);
                      AddArticleAdv(state, () => {
                        setState({
                          articleID: props.articleID,
                          adsID: "",
                        });
                        GetArticleAdvs(props.articleID, (callback) => {
                          setAdvsRes(callback);
                        });
                        setOpenDialog(false);
                      });
                    }
                  }
                }}
                color="secondary"
                variant="contained"
              >
                ثبت
              </Button>
              <Button
                sx={{ ml: 2 }}
                color="secondary"
                variant="outlined"
                onClick={() => {
                  setState({
                    articleID: props.articleID,
                    adsID: "",
                  });
                  setOpenDialog(false);
                }}
              >
                انصراف
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
      {advsRes ? (
        <DataGrid
          className="ltr-grid"
          filterModel={{
            items: filt,
          }}
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          rows={advsRes ? advsRes : []}
          page={pageState.page - 1}
          pageSize={20}
          Pagination
          onPageChange={(newPage) => {
            setPageState((old) => ({ ...pageState, page: newPage + 1 }));
          }}
          rowCount={advsRes && advsRes.length ? advsRes.length : 1}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              newFunc: newFunc,
              isLtr: true,
              rowCount: advsRes && advsRes.length ? advsRes.length : "",
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: "rowIndex",
                  sort: "asc",
                },
              ],
            },
          }}
        />
      ) : (
        ""
      )}
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"تبلیغ"}
        callback={() => {
          setProgress(true);
          DeleteArticleAdv(deleteState.id, () => {
            GetArticleAdvs(props.articleID, (callback) => {
              setAdvsRes(callback);
            });
          });
        }}
      ></DeleteRow>
    </Box>
  );
}
